import { DateTimeProvider } from '@rtkwlf/fenrir-react';

export const TimezoneFenrirV1Provider = ({
  children,
}: React.PropsWithChildren) => <DateTimeProvider>{children}</DateTimeProvider>;
